import { PaymentHistoryItemStatus } from '@clearverify/constants';

import { SxProp } from 'src/types/mui';

export const PaymentHistoryItemChipStyles: Record<PaymentHistoryItemStatus, SxProp> = {
  [PaymentHistoryItemStatus.Pending]: theme => ({
    backgroundColor: theme.palette.chip?.warning?.main,
    color: theme.palette.chip?.warning?.contrastText,
    borderColor: theme.palette.chip?.warning?.contrastText,
  }),
  [PaymentHistoryItemStatus.Failed]: theme => ({
    backgroundColor: theme.palette.chip?.error?.main,
    color: theme.palette.chip?.error?.contrastText,
    borderColor: theme.palette.chip?.error?.contrastText,
  }),

  [PaymentHistoryItemStatus.Succeeded]: theme => ({
    backgroundColor: theme.palette.chip?.success?.main,
    color: theme.palette.chip?.success?.contrastText,
    borderColor: theme.palette.chip?.success?.contrastText,
  }),

  [PaymentHistoryItemStatus.Refunded]: theme => ({
    backgroundColor: theme.palette.action.focus,
    color: theme.palette.text.primary,
    borderColor: theme.palette.text.primary,
  }),
};
